import ctx from "../../plugins/axios";

/**
 * Gets available approved Salesforce lists that can be used as RC code sources.
 * Used when creating a new SF list for the first time (no prior SF list exists for the brand).
 *
 * @param {Object} params - Parameters to filter RC source lists
 * @param {string} params.department_field - Department: 'RETAIL' or 'MEDICAL'
 * @param {string} [params.list_type] - List type (e.g., thpconly, thpc&dsst, brnd&ind, thpc&dsst&mdpr)
 * @param {string} [params.thpc_nm] - Therapeutic area name
 * @param {string} [params.dsst_nm] - Disease state name
 * @returns {Promise<*>}
 */
const getRcSourceLists = async (params) => {
  const searchParams = new URLSearchParams();

  if (params.department_field) {
    searchParams.append('department_field', params.department_field);
  }
  if (params.list_type) {
    searchParams.append('list_type', params.list_type);
  }
  if (params.thpc_nm) {
    searchParams.append('thpc_nm', params.thpc_nm);
  }
  if (params.dsst_nm) {
    searchParams.append('dsst_nm', params.dsst_nm);
  }

  return await ctx.get(`/specialty-list-rc-sources?${searchParams.toString()}`);
};

export default getRcSourceLists;